<template>
  <RygenChip class="shipment-status-chip" :label="label" :severity="severity" />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { translateEnum } from '@rygen/rygen-ui/i18n';
import { Severity } from '@rygen/rygen-ui/model';

import { ShipmentStatus } from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  status: {
    type: String as PropType<ShipmentStatus>,
    default: () => undefined,
  },
});
const { status } = toRefs(props);
const { t } = useI18n();

const label = computed((): string => {
  return status?.value
    ? translateEnum(status.value, 'ShipmentStatus')
    : t('common.loading');
});

const severity = computed((): Severity | undefined => {
  switch (status?.value) {
    case ShipmentStatus.COMPLETE:
      return Severity.INFO;
    case ShipmentStatus.IN_TRANSIT:
    case ShipmentStatus.DELIVERED:
      return Severity.SUCCESS_LIGHT;
    case ShipmentStatus.BOOKED:
      return Severity.INFO;
    case ShipmentStatus.PLANNING:
    case ShipmentStatus.CARRIER_ASSIGNED:
    case ShipmentStatus.TENDERED:
      return Severity.INFO_LIGHT;
    case ShipmentStatus.TENDER_REJECTED:
      return Severity.DANGER_LIGHT;
    default:
      return undefined;
  }
});
</script>
